
import React from 'react'
import { Link } from 'react-router-dom'

function CallbackResult() {
  return <div className='gap-20px mx-auto flex w-full h-[100vh] flex-col items-center justify-center gap-3 text-black'>
    <h3 className='text-[38px] font-medium text-black'>
      Successful
    </h3>
    {/* <p>Success!</p> */}
    <Link
      to='/'
      className='w-[250px] flex cursor-pointer justify-center rounded-full border-2 border-fitzba-bright-gold-static bg-fitzba-bright-gold-static p-[6px] text-white hover:bg-white hover:text-fitzba-bright-gold-static'
    >
      Back to Home
    </Link>
  </div>
}

export default CallbackResult
